<template>
  <div
    class="bg-cool-gray-50 py-4 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-12"
  >
  
    <div class="relative max-w-xl mx-auto">
      <div class="mb-4">
        <img
          class="object-cover object-center rounded justify-center mx-auto w-64 mb-4"
          alt="hero"
          src=".././assets/logo.png"
        />
        <h3
          class="text-xl leading-9 tracking-tight font-bold text-primary-900 sm:text-3xl sm:leading-10 text-center"
        >
          الاستفسار عن حالة التسجيل
        </h3>
      </div>

      <div class="pt-8 border-t-2 border-gray-300 mt-10">
        <ValidationObserver
          v-slot="{ handleSubmit, errors, invalid, failed }"
          v-if="!success"
        >
          <form
            @submit.prevent="handleSubmit(send)"
            class="grid grid-cols-1 row-gap-6 sm:grid-cols-4 sm:col-gap-8 text-right"
          >
            <div class="sm:col-span-4">
              <label
                for="nid"
                class="block text-lg font-bold leading-5 text-gray-900"
                >الرقم الوطني</label
              >

              <ValidationProvider
                name="nid"
                rules="required|digits:12|regex:^[1-2].*"
                v-slot="v"
              >
                <div class="mt-2 relative rounded-md shadow-sm">
                  <input
                    id="nid"
                    v-model="info.nid"
                    type="number"
                    class="form-input py-3 px-4 block w-full transition te ease-in-out duration-150 text-center"
                    :class="{ ' border border-red-500': v.errors[0] }"
                  />
                </div>
                <p
                  class="text-red-500 systemfont font-bold text-base mt-2 border-none"
                  v-html="v.errors[0]"
                ></p>
              </ValidationProvider>
            </div>
 

            <div
              class="sm:col-span-4 mt-2"
              v-if="(invalid && failed) || servererrors != null"
            >
              <div class="rounded-md bg-red-50 p-4">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <!-- Heroicon name: x-circle -->
                    <svg
                      class="h-5 w-5 text-red-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="mr-3">
                    <h3 class="text-base leading-5 font-medium text-red-500">
                      هناك أخطاء في إدخالك للحقول يجب معالجتها قبل الاستمرار
                    </h3>
                    <div
                      class="mt-2 text-base leading-5 text-red-700"
                      v-if="servererrors != null"
                    >
                      <ul class="list-disc pr-5">
                        <li class="mt-1">
                          {{ servererrors }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="sm:col-span-4 mt-1">
              <span class="w-full inline-flex rounded-md shadow-sm">
                <button
                  type="submit"
                  class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-lg leading-6 font-bold rounded-md text-white bg-primary-500 hover:bg-primary-500 font focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition ease-in-out duration-150"
                >
                  <svg
                    v-if="loading"
                    class="animate-spin -mr-1 ml-3 h-5 w-5 text-yellow-200"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>

                  الاستفسار
                </button>
              </span>
            </div>
          </form>
        </ValidationObserver>
        <div
          class="block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all mb-12"
          role="dialog"
          v-else
        >
          <div>
            <div class="mt-2 text-center sm:mt-2">
              <h3 class="text-lg font-bold leading-10 text-gray-900">
                الحالة
                <span
                  class="px-3 mr-2 inline-flex p-2 text-xl leading-5 font-semibold rounded-full"
                  :class="getStatusClass(result.status)"
                >
                  {{ getStatusText(result.status) }}
                </span>
              </h3>
              <h3
                class="text-lg font-bold leading-10 text-gray-900"
                v-if="result.electionCode != null"
              >
                الرقم الطبي
                <span
                  class="px-2 inline-flex text-2xl leading-5 font-semibold rounded-full systemfont"
                >
                  {{ result.electionCode }}
                </span>
              </h3>
              <div class="mt-2">
                <p class="text-lg font-medium leading-7 text-gray-500"></p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6">
            <span class="flex w-full rounded-md shadow-sm">
              <router-link
                to="/"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-4 bg-primary-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
                عودة للرئيسية
              </router-link>
            </span>
          </div>
        </div>
      </div>
    </div>


     <div v-if="modal" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog"
      aria-modal="true">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
 
        <div @click="modal=false" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true">
        </div>

       
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

     
        <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
          <div>
            <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <!-- Heroicon name: outline/check -->
              <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
      
            </div>
            <div class="mt-3 text-center sm:mt-5">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                عفواً
              </h3>
              <div class="mt-2">
                <p class="text-base text-gray-500">
                  {{ message }}
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6">
            <a @click="modal=false"
              class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm">
              العودة
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      success: false,
      loading: false,
      servererrors: null,
      info: {},
      result: {},
    };
  },
  methods: {
    send() {
      console.log(this.info);
      this.loading = true;

      axios.post("/check", this.info).then(
        (response) => {
          console.log(response);
          if (response.status == 200) {
            this.success = true;
            this.loading = false;
            this.result = response.data.data;
          } else {
            this.servererrors = response.data.message;
            this.loading = false;
          }
        },
        (error) => {
          this.servererrors = error.response.data.message;
          this.loading = false;
        }
      );
    },
    getStatusClass(status) {
      switch (status) {
        case 0:
          return "bg-orange-100 text-orange-800";

        case 1:
          return "bg-yellow-100 text-yellow-800";

        case 2:
          return "bg-blue-100 text-blue-800";

        case 3:
          return "bg-green-100 text-green-800";

        default:
          return "bg-gray-100 text-gray-800";
      }
    },
    getStatusText(status) {
      switch (status) {
        case 0:
          return "قيد المراجعة";

        case 1:
          return "معلق للمراجعة (مقيم غير مقيد)";

        case 2:
          return "قيد المراجعة";

        case 3:
          return "مسجل بنجاح";

        default:
          return "لم يتم معالجة";
      }
    },
  },
};
</script>
<style scoped>
input[type="number"] {
  -moz-appearance: textfield;
  direction: ltr;
}

input[type="email"] {
  direction: ltr;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.animate-spin {
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>